import { Component, OnInit, ViewChild } from '@angular/core';
import { IMyDpOptions, IMyDateModel, IMyDate } from 'mydatepicker';

import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';
import { GlobalService } from '../services/global.service';
import { PagerService } from '../services/pager.service';

import Utils from '../shared/utility';

@Component({
  selector: 'app-metrics-v2',
  templateUrl: './metrics-v2.component.html',
  styleUrls: ['./metrics-v2.component.css']
})

export class MetricsComponentV2 implements OnInit {
  public startDate: any = {};
  public endDate: any = {};
  public allTimeChecked: boolean = false;

  public allItems: any[];
  public pager: any = {};
  public pagedItems: any[];

  public showLTC: boolean = true;

  public activeView = {
    org: false,
    advisor: false,
    client: false,
  };

  public orgs: any[];
  public advisors: any[];
  public clients: any[];

  public selectedOrganizationName: string;
  public selectedAdvisorName: string;

  public datePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    editableDateField: true,
    showTodayBtn: false,
  };

  public globalMetrics: any[];
  public globalSearchMetrics: any[];
  public filteredSearch: any[];

  public isOA: boolean;
  public isS: boolean;
  public isA: boolean;
  activeMetricNameArrow: boolean;
  activeOrgNameArrow: boolean;

  public showResults: string = "'All-time' refers to the beginning of this application's availability to users in your organization, through today.";
  
  constructor(public globalService: GlobalService, public snackBarService: SnackBarService, public pagerService: PagerService, public loadingService: LoadingService) {
  }

  ngOnInit() {
    this.pagedItems = new Array(10);

    this.isOA = (Number(localStorage.getItem('orgID')) === 2 || Number(localStorage.getItem('parentID')) === 2) ? true : false;
    this.isS = (Number(localStorage.getItem('orgID')) === 371 || Number(localStorage.getItem('parentID')) === 371) ? true : false;
    this.isA = (Number(localStorage.getItem('orgID')) === 421 || Number(localStorage.getItem('parentID')) === 421) ? true : false;

    this.showLTC = !this.isOA && !this.isS && !this.isA;

    const todaysDate = new Date();

    this.startDate = { jsdate: new Date((todaysDate.getFullYear()).toString() + '-' + 1 + '-' + 1) };
    this.endDate = { jsdate: new Date(todaysDate.getFullYear().toString() + '-' + (todaysDate.getMonth() + 1) + '-' + todaysDate.getDate()) };

    //this.getOrgMetrics();
    this.getGlobalSearchMetrics();


    if (this.isOA)
      this.getGlobalOAMetrics();
    else
      this.getGlobalMetrics();

    this.getOrgMetrics();
  }

  getOrgMetrics() {

    // this.loadingService.isLoading(true);

    const metricObject = {
      startDate: this.startDate.jsdate.toUTCString(),
      endDate: this.endDate.jsdate.toUTCString(),
      //orgID: 2, //Number(localStorage.getItem('orgID')),
      allTime: this.allTimeChecked,
    }

    if ((this.startDate.jsdate >= this.endDate.jsdate) && !this.allTimeChecked) {
      this.snackBarService.add('Please make sure the start date is prior to the end date.', 1);
    } else {
      this.globalService.getMetricData(metricObject)
        .subscribe(
          orgs => {
            this.activeView = {
              org: true,
              advisor: false,
              client: false,
            }
            this.orgs = orgs;
            this.setOrgPage(1);
            this.loadingService.isLoading(false);
          },
          error => console.log(error));
    }
  }

  getAdvisorMetrics(orgID) {
    const metricObject = {
      startDate: this.startDate.jsdate.toUTCString(),
      endDate: this.endDate.jsdate.toUTCString(),
      orgID: orgID, //Number(localStorage.getItem('orgID')),
      allTime: this.allTimeChecked,
    }

    //this.loadingService.isLoading(true);

    if ((this.startDate.jsdate >= this.endDate.jsdate) && !this.allTimeChecked) {
      this.snackBarService.add('Please make sure the start date is prior to the end date.', 1);
    } else {
      this.globalService.getAdvisorMetricData(metricObject)
        .subscribe(
          advisors => {
            this.activeView = {
              org: false,
              advisor: true,
              client: false,
            }

            this.advisors = advisors;
            this.setAdvisorPage(1);
            this.loadingService.isLoading(false);
          },
          error => console.log(error));
    }
  }

  getClientMetrics(advisorID) {
    const metricObject = {
      startDate: this.startDate.jsdate.toUTCString(),
      endDate: this.endDate.jsdate.toUTCString(),
      advisorID: advisorID, //Number(localStorage.getItem('orgID')),
      allTime: this.allTimeChecked,
    }

    //this.loadingService.isLoading(true);

    if ((this.startDate.jsdate >= this.endDate.jsdate) && !this.allTimeChecked) {
      this.snackBarService.add('Please make sure the start date is prior to the end date.', 1);
    } else {
      this.globalService.getClientMetricData(metricObject)
        .subscribe(
          clients => {
            this.activeView = {
              org: false,
              advisor: false,
              client: true,
            }

            this.clients = clients;
            this.setClientPage(1);
            this.loadingService.isLoading(false);
          },
          error => console.log(error));
    }
  }

  getGlobalOAMetrics() {
    const metricObject = {
      startDate: this.startDate.jsdate.toUTCString(),
      endDate: this.endDate.jsdate.toUTCString(),
      allTime: this.allTimeChecked,
    }

    if ((this.startDate.jsdate >= this.endDate.jsdate) && !this.allTimeChecked) {
      this.snackBarService.add('Please make sure the start date is prior to the end date.', 1);
    } else {
      this.loadingService.isLoading(true);

      this.globalService.getGlobalOAMetricData(metricObject)
        .subscribe(
          data => {
            //this.loadingService.isLoading(false);
            this.globalMetrics = data.clientMetrics;
          },
          error => console.log(error));
    }
  }

  getGlobalMetrics() {
    const metricObject = {
      startDate: this.startDate.jsdate.toUTCString(),
      endDate: this.endDate.jsdate.toUTCString(),
      allTime: this.allTimeChecked,
    }

    if ((this.startDate.jsdate >= this.endDate.jsdate) && !this.allTimeChecked) {
      this.snackBarService.add('Please make sure the start date is prior to the end date.', 1);
    } else {
      this.loadingService.isLoading(true);

      this.globalService.getGlobalMetricData(metricObject)
        .subscribe(
          data => {
            //this.loadingService.isLoading(false);
            this.globalMetrics = [data.clientMetrics];
          },
          error => console.log(error));
    }
  }

  getGlobalSearchMetrics() {
    const metricObject = {
      startDate: this.startDate.jsdate.toUTCString(),
      endDate: this.endDate.jsdate.toUTCString(),
      allTime: this.allTimeChecked,
    }

    if ((this.startDate.jsdate >= this.endDate.jsdate) && !this.allTimeChecked) {
      this.snackBarService.add('Please make sure the start date is prior to the end date.', 1);
    } else {
      this.loadingService.isLoading(true);

      this.globalService.getGlobalSearchMetricData(metricObject)
        .subscribe(
          data => {
            this.globalSearchMetrics = data.result;
            this.allItems = this.globalSearchMetrics;
          },
          error => console.log(error));
    }
  }

  setOrgPage(page: number) {
    if (this.orgs.length === 1) {
      this.pagedItems = this.orgs;
      this.pager = this.pagerService.getPager(this.orgs.length, page);
      return;
    }

    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    this.pager = this.pagerService.getPager(this.orgs.length, page);
    this.pagedItems = this.orgs.slice(this.pager.startIndex, this.pager.endIndex + 1);

  }

  setAdvisorPage(page: number) {
    if (this.advisors.length === 1) {
      this.pagedItems = this.advisors;
      this.pager = this.pagerService.getPager(this.advisors.length, page);
      return;
    }

    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    this.pager = this.pagerService.getPager(this.advisors.length, page);
    this.pagedItems = this.advisors.slice(this.pager.startIndex, this.pager.endIndex + 1);

  }

  setClientPage(page: number) {
    if (this.clients.length === 1) {
      this.pagedItems = this.clients;
      this.pager = this.pagerService.getPager(this.clients.length, page);
      return;
    }

    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    this.pager = this.pagerService.getPager(this.clients.length, page);
    this.pagedItems = this.clients.slice(this.pager.startIndex, this.pager.endIndex + 1);

  }

  public selectedOrganization: number = Number(localStorage.getItem('orgID'));
  public selectedAdvisor: number = 0;

  initAdvisorMetrics(org = {ID: undefined, Name: undefined}) {
    if (org.ID >= 0) {
      this.selectedOrganization = org.ID;
      this.selectedOrganizationName = org.Name;
    }

    this.loadingService.isLoading(true);
    this.getAdvisorMetrics(this.selectedOrganization);
  }

  initClientMetrics(advisor) {
    if (advisor) {
      this.selectedAdvisor = advisor.Advisor_ID;
      this.selectedAdvisorName = advisor.Name;
    }

    this.loadingService.isLoading(true);
    this.getClientMetrics(this.selectedAdvisor);
  }

  initOrgMetrics() {
    this.loadingService.isLoading(true);
    this.getOrgMetrics();
  }

  generateData(e) {
    this.getGlobalSearchMetrics()

    if (this.isOA)
      this.getGlobalOAMetrics();
    else
      this.getGlobalMetrics();

    if (!this.activeView.org && !this.activeView.advisor && !this.activeView.client)
      this.activeView.org = true;

    if (this.activeView.org) {
      this.getOrgMetrics();
    } else if (this.activeView.advisor) {
      this.getAdvisorMetrics(this.selectedOrganization);
    } else if (this.activeView.client) {
      this.getClientMetrics(this.selectedAdvisor);
    }
  }

  filterSearchItem(value) {
    this.filteredSearch = Object.assign([], this.allItems).filter(
      item => {
        if (value.length >= 1) {
          if (item.Type == 'Organization')
            return (item.OrganizationName).toLowerCase().includes(value.toLowerCase())
          if (item.Type == 'Advisor')
            return (item.AdvisorName).toLowerCase().includes(value.toLowerCase())
          if (item.Type == 'Client')
            return (item.ClientName).toLowerCase().includes(value.toLowerCase())
        } else {
          this.filteredSearch = [];
          return;
        }
      }
    );
  }

  @ViewChild('clientSearchInput') clientSearch; 

  loadSearchItem(item) {
    this.loadingService.isLoading(true);

    if (item.Type == 'Organization') {
      this.selectedOrganizationName = item.OrganizationName;
      this.selectedOrganization = item.OrgID;
      this.getAdvisorMetrics(item.OrgID);
    } else if (item.Type == 'Advisor') {
      this.selectedAdvisorName = item.AdvisorName;
      this.selectedOrganizationName = item.OrganizationName;
      this.selectedAdvisor = item.AdvID;
      this.getClientMetrics(item.AdvID);
    } else if (item.Type == 'Client') {
      this.selectedAdvisorName = item.AdvisorName;
      this.selectedOrganizationName = item.OrganizationName;
      this.selectedAdvisor = item.AdvID;
      this.getClientMetrics(item.AdvID);
    }

    this.clientSearch.nativeElement.value = '';
    this.filteredSearch = [];
  }

  downloadReport() {
    const metricObject = {
      startDate: this.startDate.jsdate.toUTCString(),
      endDate: this.endDate.jsdate.toUTCString(),
      allTime: this.allTimeChecked,
    }

    if (false) {
      this.snackBarService.add('Please make sure the start date is prior to the end date.', 1);
    } else {
      this.globalService.getMetricDownloadableReport(metricObject)
        .subscribe(
          data => {
            this.loadingService.isLoading(false);
            this.snackBarService.add('Please wait while your usage report is being generated.', 0);
          },
          error => console.log(error));
    }
  }

  formatName(name) {
    var splitStr = name.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    }
    return splitStr.join(' '); 
  }

  numberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }



  sort(colName) {

    if (colName == 'metricName') {
      this.globalMetrics.sort((a, b) => a.Name.localeCompare(b.Name ));
      this.activeMetricNameArrow = true;
    }

    if (colName == 'Name') {
      this.pagedItems.sort((a, b) => a.Name.localeCompare(b.Name ));
      this.activeOrgNameArrow = true;
    }

  }

  onDateChanged() {

  }

}
